<template>
    <div class="page">
        <p>
            {{ date }}
        </p>
        <p>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br />{{ userStore.user.address }} {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
            <br>
            {{ userStore.user.ssn }} | {{ userStore.user.dob }}
        </p>
        <p>
            {{ creditBureau.address_name }} <br />
            {{ address.street }} <br />
            {{ address.city }}, {{ address.state_abbreviation }} {{ address.zipcode }}
        </p>
        <p>
            <strong>RE:</strong>
            Fraudulent Inquires. You Violated the United States Code Law 15 U.S.C. § 1681n. I demand you to comply
        </p>

        <p class="letter-content">
            <strong>NOTICE</strong>, this letter is a follow-up to the original letter I sent to your company on <strong>{{ originalDisputeDate != null ? moment(originalDisputeDate).format('LL') : '(Insert Date)' }}</strong>.
            It seems that you are being willfully noncompliant.
            Specifically about the following unauthorized, false and fraudulent credit inquiries that were made by the following companies:
        </p>
        <h3>Inquiries in Dispute:</h3>
        <p v-for="(inquiry, iteration) in reportStore.getInquiries(1, creditBureau.name)">
            {{ iteration+1 }}. {{ inquiry.creditor_name }}
            <br />
            <strong>
                Delete this Inquiry for fraudulent reporting becuase 
                <template v-if="inquiry.reason">
                    {{ inquiry.reason }}
                </template>
                The Inquiry was reported on {{ inquiry.date_of_inquiry }}
            </strong>
            
            <br />
        </p>
        <p class="letter-content">
            My first request was simple. And you failed. Miserably. You provided absolutely no documentation or proof that the inquiries in question were obtained pursuant to the Fair Credit Reporting Act. Once again, you gave an entirely inappropriate response by encouraging me to deal directly with the furnisher.
        </p>
        <p>
            I have maintained the previous record of my communication with your company <strong>{{ originalDisputeDate != null ? moment(originalDisputeDate).format('LL') : '(Insert Date)' }}</strong>. If your company Fails to remove these fraudulent inquiries within 30 days of receipt of this certified letter. I am strongly considering filing a small claims action against your company, seeking $1,000 per violation for knowingly and purposefully furnishing deceptive forms, knowingly enabling Identity Fraud and sharing my personal information without my written permission or my consent.
        </p>
        <p>
            Enclosed are copies of ID and proof of mailing address.
        </p>
        <p style="page-break-after: always;">
            Sincerely,
            <br> <br>
            <template v-if="userStore.user.middle_name">
                {{ userStore.user.firstname }} {{userStore.user.middle_name}} {{ userStore.user.lastname }}
                <br>
            </template>
            <template else>
                Sincerely,
                <br> <br>
                {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            </template>
        </p>
        <div class="page-content">
            <h1 style="padding: 0rem; 3rem; text-align: center;">Enclosures</h1>
            <p style="padding-top:3rem; text-align: center;">
                <img v-if='userStore.user.ssn_image_url' v-bind:src='userStore.user.ssn_image_url' width='300' height='200' />
                <img v-if='userStore.user.identity_image_url' v-bind:src='userStore.user.identity_image_url' width='300' height='200' />
            </p>
            <p v-if='userStore.user.address_verify_image_url'>
                <img v-bind:src='userStore.user.address_verify_image_url' width='300' height='200' />
            </p>
        </div>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useReportStore } from '../../stores/ReportStore.js'
    import { useUserStore } from '../../stores/UserStore.js'
    import moment from 'moment';
    export default {
        props: {
            creditBureau: {
                type: [Array, Object]
            },
            originalLetterDate: {
                type: String
            }
        },
        setup(props) {
            const address = _.find(props.creditBureau.addresses, { 'id': props.creditBureau.selected_address });
            return {
                date: ref(moment().format('LL')),
                reportStore: useReportStore(),
                userStore: useUserStore(),
                _: _,
                address,
                moment:moment
            };
        }
    };
</script>
